import React from 'react';
import styled from 'styled-components';
import { FeatureListItemDto } from '../types';

type Props = {
  features: FeatureListItemDto[];
  selectedFeature: FeatureListItemDto | null;
  onSelect: (feature: FeatureListItemDto) => void;
};

const FeatureList: React.FC<Props> = ({ features, selectedFeature, onSelect }) => {
  return (
    <ColumnWrapper>
      <TitleWrapper>מודולים</TitleWrapper>
      <ListWrapper>
        {features.map((feature) => {
          const isSelected = selectedFeature?.formId === feature.formId;
          return (
            <Item
              key={feature.formId}
              $isSelected={isSelected}
              onClick={() => onSelect(feature)}
              tabIndex={0}
              role="button"
              aria-label={feature.displayDescHe}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onSelect(feature);
              }}
            >
              <ItemText>{feature.displayDescHe}</ItemText>
              {/* <ItemSubText>{feature.systemDescEn}</ItemSubText> */}
            </Item>
          );
        })}
      </ListWrapper>
    </ColumnWrapper>
  );
};

export default FeatureList;

const ColumnWrapper = styled.div`
  min-width: 25%;
  height: 100%;
  display: flex;
  flex-flow: column;
  gap: 1em;
  padding: 0.75em;
  background: var(--bg-light, #f5f7fa);
  border-radius: 3px 25px 25px 3px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75em 1em;
  font-weight: 600;
  font-size: 1.1em;
  color: var(--primary-green, #297f76);
  font-family: 'Assistant', sans-serif;
  line-height: 1;
`;

const ListWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  gap: 0.5em;
  padding: 0.75em 1em;
  background: var(--bg-white, #ffffff);
  border-radius: 12px;
  overflow-y: auto;
  box-shadow: 0 1px 3px var(--shadow-light, rgba(0, 0, 0, 0.06));
  &::-webkit-scrollbar {
    width: 0;
  }
  scrollbar-width: none;
`;

const Item = styled.div<{ $isSelected: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25em;
  padding: 0.75em 1em;
  background: ${(props) =>
    props.$isSelected
      ? 'linear-gradient(135deg, var(--primary-green, #297F76) 0%, #1e8449 100%)'
      : '#f8f9fa'};
  color: ${(props) => (props.$isSelected ? '#ffffff' : '#6b7280')};
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: ${(props) =>
    props.$isSelected
      ? '0 2px 6px rgba(41, 127, 118, 0.2)'
      : '0 1px 3px rgba(0, 0, 0, 0.1)'};
  outline: none;

  &:hover {
    background: ${(props) =>
      props.$isSelected ? 'rgba(41, 127, 118, 0.9)' : '#e8f5e9'};
    color: ${(props) => (props.$isSelected ? '#ffffff' : '#4b5563')};
    box-shadow: ${(props) =>
      props.$isSelected
        ? '0 3px 8px rgba(41, 127, 118, 0.3)'
        : '0 2px 4px rgba(41, 127, 118, 0.15)'};
  }
`;

const ItemText = styled.span`
  font-weight: 600;
  font-size: 1em;
`;

const ItemSubText = styled.span`
  font-size: 0.8em;
  opacity: 0.7;
`;
